export default "__VITE_ASSET__TPn$o8r7__";